export default __webpack_public_path__ + "static/media/product2.49600ff6.jpg";